const SUPPORTED_LOCALES = ['es', 'en'] as const;
type SupportedLocale = typeof SUPPORTED_LOCALES[number];

export function detectBrowserLocale(): SupportedLocale {
  const browserLang = (navigator.language || 'en').slice(0, 2).toLowerCase();
  return SUPPORTED_LOCALES.includes(browserLang as SupportedLocale)
    ? (browserLang as SupportedLocale)
    : 'en';
}

export function getUserLocale(): SupportedLocale {
  return detectBrowserLocale();
}
